import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AudioRecorder } from 'react-audio-voice-recorder';
// import { TabView, TabPanel } from 'primereact/tabview';
import { IRequirementMast, Job_Type, Req_Term } from "../../../models/RequirementMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { EmptyRequirement } from "../EmptyRequirement";
// import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { ICityMastDropdown, IClientCompanyDropdown, IClientCategoriesDropdown, IEndClientsDropdown, IIndustryMastDropdown, ISkillCategoriesDropdown, IStateMastDropdown, IVisaDropdown } from "../../../models/IDropdown";
import { JobType, Term, Priority, InterviewProcess, Positions, EClient_Communication, client_Type, special_Constraints, ResumesPerPositions } from "../../../models/FDropdown";
// import { Editor } from "primereact/editor";
import { IVendorCompanyInfo } from "../../../models/VendorCompanyInfo";
import { useNavigate } from "react-router-dom";
import { IClientTnfr } from "../../clientTransfer/ClientTnfr";
import { format } from "date-fns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { IReq_Update } from "../../../models/Requirement_Update";
import { JVMultiselect } from "../../../shared/JVMultiselect";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { Card } from "primereact/card";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { IAllRequirements } from "../../../models/AllRequirements";
import { Tag } from "primereact/tag";
import { IModel2 } from "./TableMy";
import { Publish } from "../Publish";
import { Tooltip } from "primereact/tooltip";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IEscalationList {
    id?: number,
    pO_ID?: number,
    vendor_Type?: number,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    added_By?: string,
    company?: string,
    branch?: string,
    escalation_Subject?: string,
    escalation_Comment?: string,
    escalation_Status?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

const clientCompanySchema = yup.object().shape({
    client_company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1).required(),
        vendor_Company_Name: yup.string().required()
    })
});

const schema = yup.object({
    // client_company: yup.object().shape({
    //     vendor_Company_ID: yup.number().min(1, "Client is required*").required("Client is required*"),
    //     vendor_Company_Name: yup.string().required()
    // }),
    req_Type: yup.number().required("Req Type is required*"),
    req_Job_Title: yup.string().required("Job Title is required*").min(3),
    req_Term: yup.number().required("Term is required*"),
    req_Duration: yup.string().when('req_Term', val => {
        return (val === Req_Term.Permanent) ?
            yup.string().nullable() :
            yup.string().required("Duration is required*")
    }),
    job_Type: yup.number().required("Job Type is required*"),
    state: yup.object().when('job_Type', val => {
        return (val === Job_Type.Remote) ?
            yup.object().nullable() :
            yup.object().shape({
                state_ID: yup.number().min(1, "State is required*").required("State is required*"),
                state_Name: yup.string().required()
            })
    }),
    city: yup.object().when('job_Type', val => {
        return (val === Job_Type.Remote) ?
            yup.object().nullable() :
            yup.object().shape({
                city_ID: yup.number().min(1, "City is required*").required("City is required*"),
                city_Name: yup.string().required()
            })
    }),
    req_Rate: yup.string().required("Rate/Salary is required*"),
    // req_EndClient: yup.string().required("End Client is required*"),
    endClient: yup.object().nullable(),
    industry_Id: yup.number().min(1, "Industry is Required*").required("Industry is Required*"),
    req_NoOfPositions: yup.number().required("Positions is required*"),
    req_NoOfResumePerPositions: yup.number().required("Resumers Per Positions is required*"),
    req_Category: yup.number().min(1, "Skills Category is required*").required("Skills Category is required*"),
    req_Priority: yup.number().required("Priority is required*"),
    reqType: yup.number().min(1, "Client Category is required*").required("Client Category is required*"),
    client_Type: yup.number().required("Client Type is required*"),
    // special_Constraint: yup.number().required("Special Constraints is required"),
    travelReq: yup.string().required("Travel Required is required*"),
    req_InterviewProcess: yup.number().required("Interview Process is required*"),
    // client_Communication: yup.string().required("Cslient Communication is required*"),
    // req_Hold_UnHoldStatus: yup.string().required("Status is required*"),
    req_RequiredSkill: yup.string().max(100, "Max 100 character allowed for required skill.").required("RequiredSkill is required*"),
    req_Sub_Category: yup.number().nullable(),
    // email_Message_ID:yup.string().required("Meassage ID is required*")
});

interface Iprops {
    singleData: IRequirementMast,
    open: boolean,
    hideDialog?: () => void,
    toast: any,
    reload?: boolean,
    setReload?: (is: boolean) => void,
    ShowCelebration: () => void,
    reqFrom?: string,
}

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IRequirementMast>();
    const [vendorCompanyInfo, setVendorCompanyInfo] = useState<IVendorCompanyInfo | undefined>(undefined);
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [industry, setIndustry] = useState<Array<IIndustryMastDropdown>>();

    // const [activeTab, setActiveTab] = useState(0);
    const [clients, setClients] = useState({ clients: [], selectedClient: 0 } as { clients: Array<IClientTnfr>, selectedClient: number });
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [endClients, setEndClients] = useState<Array<IEndClientsDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [subskillCategories, setSubSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();

    const [clientCategories, setClientCategories] = useState<Array<IClientCategoriesDropdown>>();
    const [description, setDescription] = useState("");
    const [additionInfo, setAdditionInfo] = useState("");
    const [formValues, setFormValues] = useState({ isJTermP: false, isJTypeR: false } as { isJTermP: boolean, isJTypeR: boolean });
    const [selectedVisa, setSelectedVisa] = useState<Array<IVisaDropdown>>();

    const [recruiterAllocationAutoList, setRecruiterAllocationAutoList] = useState<any>([]);
    const [shwSkillDrp, setShwSkillDrp] = useState<any | null>(null);
    const [selectedEClient_Communication, setSelectedEClient_Communication] = useState<Array<{ name: string }>>();
    const [specialConstraints, setSpecialConstraints] = useState<Array<{ name: string }>>();
    const [reqTable, setReqTable] = useState({ contact_Person_Id: 0, open: false, loading: false, } as { contact_Person_Id: number, open: boolean, loading: boolean });
    const [historyTableData, setHistoryTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };
    const [canUpdate, setCanUpdate] = useState(false);
    const [alreadyPostPoc, setAlreadyPostPoc] = useState(false);
    const [existingPoc, setExistingPoc] = useState({});
    const [existingPocData, setExistingPocData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [selfClietnModal, setSelfClietnModal] = useState({ reqs: [], open: false } as { reqs: any[], open: boolean });
    const [contiune, setContiune] = useState(false);

    const [openEscalationModal, setOpenEscalationModal] = useState({ singleData: {}, open: false } as { singleData: IEscalationList, open: boolean });
    const [escalationTableData, setEscalationTableData] = useState({ tableData: [], loading: false } as { tableData: IEscalationList[], loading: boolean });

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IRequirementMast>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRequirement,
        shouldFocusError: false
    });

    useEffect(() => {

        if (skillCategories) {
            const subscription = watch((value, { name, type }) => {
                if (name === "req_Category") {
                    if (value.req_Category != 0 && value.req_Category != null) {
                        loadSubSkillCategories(value.req_Category);
                    }
                }
                if (name === "req_Term") {
                    if (value.req_Term === Req_Term.Permanent) setFormValues((val) => { return { ...val, isJTermP: true } });
                    else setFormValues((val) => { return { ...val, isJTermP: false } });
                } else if (name === "job_Type") {
                    if (value.job_Type === Job_Type.Remote) setFormValues((val) => { return { ...val, isJTypeR: true } });
                    else setFormValues((val) => { return { ...val, isJTypeR: false } })
                }
                //  else if (name === "req_Job_Title") {
                //     if (value.req_Job_Title && value.req_Job_Title !== "") {
                //         const job_title = value.req_Job_Title.toLowerCase();
                //         const job_title_words = job_title.split(" ");
                //         for (let i = 0; i < job_title_words.length; i++) {
                //             const req_Category = skillCategories?.find(sc => sc.req_CategoryName?.toLowerCase().includes(job_title_words[i]));
                //             if (req_Category) {
                //                 setValue('req_Category', req_Category?.req_CategoryID);
                //                 break;
                //             }
                //         }
                //         // console.log(skillCategories, job_title, req_Category);
                //     } else setValue('req_Category', 0);
                // }
            });
            return () => subscription.unsubscribe();
        }
    }, [watch, skillCategories]);

    const navigate = useNavigate();
    useEffect(() => {
        loadVisa();
        loadIndsutry();
    }, []);
    useEffect(() => {
        if (props.open && !props.singleData.req_ID && props.hideDialog) myTop10Clients();
    }, [props.open]);
    useEffect(() => {
        if (props.singleData.req_ID) loadData();
    }, [props.singleData.req_ID]);
    useEffect(() => {
        if (props.singleData.pV_Contact_PersonID) setClients({ clients: [], selectedClient: props.singleData.pV_Contact_PersonID });
    }, [props.singleData.pV_Contact_PersonID]);

    const loadData = async () => {
        setLoading(true);
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
            loadSubSkillCategories(data?.req_Category || 0);
            setLoading(false);
            if (data.reqType == 1) {
                setCanUpdate(true);
            } else {
                setCanUpdate(false);
            }
            console.log(canUpdate);
        } else setLoading(false);
    }
    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }
    const loadIndsutry = async () => {
        const response = await Fetch("Dropdown/industries", "GET", null, null, null);
        if (response) {
            const data: Array<IIndustryMastDropdown> = await response.json();
            setIndustry(data);
        }
    }
    const myTop10Clients = async () => {
        setLoading(true);
        const response = await Fetch(`Sub_Vendor_Contact_Person_Mast/myTop10ContactPersons`, "GET", null, null, props.toast);
        if (response) {
            const data: Array<IClientTnfr> = await response.json();
            setClients({ clients: data, selectedClient: 0 });
            setLoading(false);
        } else setLoading(false);
    }

    const searchClients = async (client: number = 0) => {
        const valid = await clientCompanySchema.isValid({
            client_company: control._formValues.client_company
        });
        if (valid) {
            setLoading(true);
            setClients({ clients: [], selectedClient: 0 });
            const responseI = await Fetch(`Vendor_Company_Mast/info`, "GET", null, `vendor_company_id=${control._formValues.client_company.vendor_Company_ID}`, null);
            if (responseI) {
                const data: IVendorCompanyInfo = await responseI.json();
                setVendorCompanyInfo(data);
            }
            if (props.singleData.req_ID && typeof (client) === "number") {
                const response = await Fetch(`Sub_Vendor_Contact_Person_Mast/myContactPersonsById`, "GET", null, `contact_person_id=${client}`, props.toast);
                if (response) {
                    const data: Array<IClientTnfr> = await response.json();
                    setClients({ clients: data, selectedClient: client });
                    setLoading(false);
                } else setLoading(false);
            } else {
                const response = await Fetch(`Sub_Vendor_Contact_Person_Mast/myContactPersonsByCompany`, "GET", null, `company_id=${control._formValues.client_company.vendor_Company_ID}`, props.toast);
                if (response) {
                    const data: Array<IClientTnfr> = await response.json();
                    if (data.length === 0) {
                        props.toast.current.show({ severity: 'error', detail: "Client Not Exist in System. Please add First.", life: 3000 });
                    } else if (data.length === 1 && data[0].contact_Person_Id) {
                        setClients({ clients: data, selectedClient: data[0].contact_Person_Id });
                        // setReqTable({ vendor_Company_ID: rowData.vendor_Company_ID, open: true, loading: true });
                    } else {
                        setClients({ clients: data, selectedClient: client });
                    }
                    setLoading(false);
                } else setLoading(false);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Please Type a Valid Client", life: 3000 });
        }
    }

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadEndClient = async (filter: string | null) => {
        const response = await Fetch("Dropdown/endClients", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IEndClientsDropdown> = await response.json();
            setEndClients(data);
        }
    }
    const completeMethodEndClient = (event: { query: string }) => {
        loadEndClient(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_Form", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        if (event.query.length >= 3) {
            loadClientCompanies(event.query);
        }
    }

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            setSkillCategories(data);
        }
    }

    const loadSubSkillCategories = async (parent_id: number) => {
        const response = await Fetch("Dropdown/skillsSubCategories", "GET", null, `parent_id=${parent_id}`, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            setSubSkillCategories(data);
        }
    }

    const GetRecruiterAllocationAutoList = async () => {
        const response = await Fetch("Requirement_CateGoryLInfo", "GET", null, null, props.toast);
        if (response) {
            let data = await response.json();
            // data = data.filter((el: { recruiterAllocationAuto: boolean; })=> el.recruiterAllocationAuto === true);
            setRecruiterAllocationAutoList(data);
        }
    }

    const loadClientCategories = async () => {
        const response = await Fetch("Dropdown/clientCategories", "GET", null, null, null);
        if (response) {
            const data: Array<IClientCategoriesDropdown> = await response.json();
            setClientCategories(data);
        }
    }

    useEffect(() => {
        if (data) {
            data.city = {
                city_ID: data.req_City,
                city_Name: data.city_Name
            }
            data.state = {
                state_ID: data.req_State,
                state_Name: data.state_Name
            }
            data.client_company = {
                vendor_Company_ID: data.vendor_Company_ID,
                vendor_Company_Name: data.vendor_Company_Name
            }
            if (data.endClient_ID) {
                data.endClient = {
                    end_Client_Id: data.endClient_ID,
                    end_Client_Name: data.req_EndClient
                }
            } else {
                data.endClient = {
                    end_Client_Id: 0,
                    end_Client_Name: ''
                }
            }
            //for visa selection
            if (data.visa && data.visa !== "") {
                const visa_Name_Array = data.visa.split(',');
                const temp_selected_visa = visa?.filter(visa => visa_Name_Array?.includes(visa.visa_Name));
                setSelectedVisa(temp_selected_visa);
            }

            //for client communication selection
            if (data.client_Communication && data.client_Communication !== "") {
                const communication_Name_Array = data.client_Communication.split(',');
                const temp_selected_communication = EClient_Communication?.filter(communication => communication_Name_Array?.includes(communication.name));
                setSelectedEClient_Communication(temp_selected_communication);
            }

            if (data.special_Constraint && data.special_Constraint !== "") {
                const special_Name_Array = data.special_Constraint.split(',');
                const temp_selected_special = special_Constraints?.filter(special_Constraints => special_Name_Array?.includes(special_Constraints.name));
                setSpecialConstraints(temp_selected_special);

            }

            //for special constraints

            // console.log(data.visa);
            // console.log(data.client_Communication);
            //
            reset(data);
            if (data.req_JobDescription) setDescription(data.req_JobDescription);
            if (data.additional_info) setAdditionInfo(data.additional_info);
            if (data.pV_Contact_PersonID && data.pV_Contact_PersonID !== 0)
                searchClients(data.pV_Contact_PersonID);
            else
                setClients({ clients: [], selectedClient: 0 });
        }
    }, [data]);

    //     const table = `<table>
    //     <thead>
    //         <th>ReqID</th>
    //         <th>Job Title</th>
    //         <th>Duration</th>
    //         <th>Location</th>
    //         <th>Job Type</th>
    //         <th>Rate/Salary</th>
    //         <th>End Client</th>
    //         <th>Job Term</th>
    //         <th>Positions</th>
    //         <th>Skills Category</th>
    //         <th>Priority</th>
    //         <th>Travel</th>
    //         <th>Interview Process</th>
    //         <th>Skills Required</th>
    //     </thead>
    //     <tbody>
    //         <td>${data.req_ID}</td>
    //         <td>${data.req_Job_Title}</td>
    //         <td>${data.req_Duration}</td>
    //         <td>${data.city_Name}, ${data.state_Name}</td>
    //         <td>${data.job_Type}</td>
    //         <td>${data.req_Rate}</td>
    //         <td>${data.req_EndClient}</td>
    //         <td>${data.req_Term}</td>
    //         <td>${data.req_NoOfPositions}</td>
    //         <td>${data.req_Category_Name}</td>
    //         <td>${data.req_Priority}</td>
    //         <td>${data.travelReq}</td>
    //         <td>${data.req_InterviewProcess}</td>
    //         <td>${data.req_RequiredSkill}</td>
    //     </tbody>
    // </table>
    // <p><b>Job Description -</b> \n${data.req_JobDescription}</p>`;
    //     setUpdateDetails(table);

    useEffect(() => {
        loadClientCategories();
        GetRecruiterAllocationAutoList();
        loadSkillCategories();
    }, []);

    const saveToDB = async (body: any) => {
        setLoading(true);
        // console.log(body);
        // if (!existingPoc.pV_Contact_PersonID) {
        // }
        const method = props.singleData?.req_ID ? "PUT" : "POST";
        const message = props.singleData?.req_ID ? "Updated Successfully" : "Added Successfully";

        body.req_City = body.city ? body.city?.city_ID : body.req_City;
        body.req_State = body.state ? body.state?.state_ID : body.req_State;
        body.pV_Contact_PersonID = clients.selectedClient;
        body.req_EndClient = body.endClient?.end_Client_Name;
        body.endClient_ID = body.endClient?.end_Client_Id;
        body.req_JobDescription = description;
        body.city_Name = body.city?.city_Name;
        body.state_Name = body.state?.state_Name;
        body.vendor_Company_Name = body.client_company?.vendor_Company_Name;
        body.req_Category_Name = skillCategories?.find(d => d.req_CategoryID === body.req_Category)?.req_CategoryName;
        body.industry_Name = industry?.find(d => d.industry_Id === body.industry_Id)?.industry_Name;
        body.special_Constraint = body.special_Constraint;
        body.additional_info = additionInfo;
        body.pOC_Transfer_Req = 0;

        delete body.city;
        delete body.state;
        delete body.client_company;
        delete body.endClient;


        if (method === "POST") { delete body.req_EditedBy; delete body.req_Allocated_By; }
        let query = '';
        if (alreadyPostPoc == true) {
            query = `isCheckExistReq=${1}`;
        };

        const req_updates = JSON.stringify(body);
        const response = await Fetch("Requirement_MAST", method, { requirement: body, requirementJsonString: req_updates }, query, props.toast);

        if (response) {
            // const data: Array<IAllRequirements> = await response.json();
            // setExistingPocData({ tableData: existingPoc.tableData, loading: false });
            setExistingPoc(prev => prev = body);
            let xyzData: any = await response.json();
            setExistingPocData({ tableData: xyzData.reqList, loading: false });
            if (xyzData?.error) {
                props.toast.current.show({ severity: 'error', detail: xyzData.error, life: 3000 });
                setLoading(false);
                onHide();
            } else {
                if (xyzData.type === 2 && props?.reqFrom && props?.reqFrom === 'ClientTransfer') {
                    props.toast.current.show({ severity: 'error', detail: xyzData.message, life: 3000 });
                    setLoading(false);
                    setSelfClietnModal({ reqs: xyzData.reqList, open: true });
                } else {
                    if (props.hideDialog) {
                        if (method === "POST") {
                            const data: any = xyzData;
                            if (data?.type === 2) {
                                setAlreadyPostPoc(true);
                                //  props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                                // if (data?.completed === true) { props.ShowCelebration(); }
                                if (props.setReload) props.setReload(!props.reload);
                                //onHide();
                                setLoading(false);
                            } else if (data?.type === 1) {
                                props.toast.current.show({ severity: 'error', detail: data.message, life: 3000 });
                                if (data.completed === true) { props.ShowCelebration(); }
                                // if (TargetCompleted.completed === false) props.toast.current.show({ severity: 'info', detail: "Target Not Completed", life: 3000 });
                                if (props.setReload) props.setReload(!props.reload);
                                onHide();
                                setLoading(false);
                                setAlreadyPostPoc(false);

                            } else {
                                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                                if (data?.completed === true) { props.ShowCelebration(); }
                                if (props.setReload) props.setReload(!props.reload);
                                onHide();
                                setLoading(false);
                                setAlreadyPostPoc(false);

                            }
                            setContiune(false);
                        } else {
                            const messageText = xyzData.data;
                            if (messageText === "Can't Update") {
                                props.toast.current.show({ severity: 'error', detail: "Submission is Done on this Requirement, Can't Update.", life: 3000 });
                                if (props.setReload) props.setReload(!props.reload);
                                onHide();
                                setLoading(false);

                            }
                            else if (messageText === "updated") {
                                console.log(messageText)
                                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                                if (props.setReload) props.setReload(!props.reload);
                                onHide();
                                setLoading(false);

                            }
                            else {
                                const data: any = await response.json();
                                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                                if (data.completed === true) { props.ShowCelebration(); }
                                if (props.setReload) props.setReload(!props.reload);
                                props.hideDialog();
                                // props.setReload(!props.reload);
                                onHide();
                                setLoading(false);
                            }
                            setLoading(false);
                            setContiune(false);
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                        navigate("/salesMyRequirement");
                    }
                }
            }
        } else
            setExistingPocData({ tableData: existingPocData.tableData, loading: false });

        setLoading(false);
    }

    // const saveUpdate = async () => {
    //     setLoading(true);
    //     const body: IReq_Update = { req_ID: props.singleData.req_ID, details: updateDetails };
    //     const response = await Fetch("Requirement_MAST/reqUpdate", "POST", body, null, props.toast);

    //     if (response) {
    //         props.toast.current.show({ severity: 'success', detail: "Saved Successfully.", life: 3000 });
    //         if (props.setReload) props.setReload(!props.reload);
    //         if (props.hideDialog) props.hideDialog();
    //         setUpdateDetails("");
    //         setLoading(false);
    //     } else setLoading(false);
    // }

    function onSubmit(data: any) {
        //    setExistingPoc(data);
        //setExistingPoc({ singleData: data });
        // console.log(existingPoc);
        if (props.hideDialog && (typeof (clients.selectedClient) !== "number" || clients.selectedClient === 0)) {
            props.toast.current.show({ severity: 'error', detail: "Choose a Client Contact Person!", life: 3000 });
        } else if (description.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Fill the Job Description!", life: 3000 });
        } else if (selectedVisa === undefined || selectedVisa.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Choose Work Authorization!", life: 3000 });
        } else {
            data.visa = "";
            selectedVisa.forEach((visa, index) => {
                if (index < (selectedVisa.length - 1)) data.visa += (visa.visa_Name + ",");
                else data.visa += visa.visa_Name;
            });

            if (selectedEClient_Communication === undefined || selectedEClient_Communication.length === 0) {
                props.toast.current.show({ severity: 'error', detail: "Choose EClient Communication!", life: 3000 });
            } else {
                data.client_Communication = "";
                selectedEClient_Communication.forEach((item, index) => {
                    if (index < (selectedEClient_Communication.length - 1)) data.client_Communication += (item.name + ",");
                    else data.client_Communication += item.name;
                });


                if (specialConstraints === undefined || specialConstraints.length === 0) {
                    props.toast.current.show({ severity: 'error', detail: "Choose Special Constraints", life: 3000 });
                }
                // else if(data.is_POC_Post==true ){
                //     setShowError(true);
                //     // props.toast.current.show({ severity: 'error', detail: "You cannot update if client category is implementation partner", life: 3000 });
                // }
                else {
                    data.special_Constraint = "";
                    specialConstraints.forEach((item, index) => {
                        if (index < (specialConstraints.length - 1)) data.special_Constraint += (item.name + ",");
                        else data.special_Constraint += item.name;
                    });
                    // setExistingPoc(prev => prev = data);
                    saveToDB(data);
                }
            }

        }
        // console.log(clients.selectedClient);
    };



    const onHide = () => {
        if (props.hideDialog) props.hideDialog();
        let emptyRequirement = EmptyRequirement;
        emptyRequirement.req_Category = 0;
        emptyRequirement.req_Category_Name = '';
        reset(emptyRequirement);
        setClients({ clients: [], selectedClient: 0 });
        setDescription('');
        setAdditionInfo('');
        setVendorCompanyInfo(undefined);
        setFormValues({ isJTermP: false, isJTypeR: false });
        setSelectedVisa(undefined);
        setSelectedEClient_Communication(undefined);
        setSpecialConstraints(undefined);
        setShwSkillDrp(null);
        setContiune(false);
    }

    // const cpnBodyTemplate = (rowData: IClientContactPerson) => {
    //     return (<span>{rowData.contact_Person_Name}</span>);
    // }
    // const cnBodyTemplate = (rowData: IClientContactPerson) => {
    //     return (<span>{rowData.vendor_Company_Name}</span>);
    // }
    // const dBodyTemplate = (rowData: IClientContactPerson) => {
    //     return (<span>{rowData.designation_Name}</span>);
    // }
    // const pnBodyTemplate = (rowData: IClientContactPerson) => {
    //     return (<span>{rowData.phone_No}</span>);
    // }
    const getClienttHistoryTable = async (data: IAllRequirements) => {
        setHistoryTableData({ tableData: historyTableData.tableData, loading: true });

        const response = await Fetch("Requirement_MAST/getTodayHistory", "GET", null, `contact_Person_Id=${data.contact_Person_Id}`, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setHistoryTableData({ tableData: data, loading: false });
        } else setHistoryTableData({ tableData: historyTableData.tableData, loading: false });

    }

    const sBodyTemplate = (rowData: IClientTnfr) => {
        return (<span>{rowData.blackListed_Status === "0" ? "Active" : "BlackListed"}</span>); //need to discuss!!
    }
    const radioBodyTemplate = (rowData: IClientTnfr | any) => {

        return (
            <RadioButton inputId={rowData.contact_Person_Name} name={rowData.vendor_Company_Name} value={rowData.contact_Person_Id} onChange={(e) => { setClients({ clients: clients.clients, selectedClient: e.value }); getClienttHistoryTable(rowData); setReqTable({ contact_Person_Id: rowData.contact_Person_Id, open: true, loading: true }); }} checked={(clients.selectedClient === rowData.contact_Person_Id)} />
        );
    }


    const onClear = () => {
        let emptyRequirement = EmptyRequirement;
        if (props.singleData.req_ID != 0) {
            emptyRequirement.req_Category = shwSkillDrp?.req_CategoryID;
            emptyRequirement.req_Category_Name = shwSkillDrp?.req_CategoryName;
        }
        // else {
        //     emptyRequirement.req_Category = 0;
        //     emptyRequirement.req_Category_Name = '';
        // }
        reset(emptyRequirement);
        // console.log(emptyRequirement);
        // console.log(EmptyRequirement);
        setDescription("");
        setAdditionInfo("");
        setFormValues({ isJTermP: false, isJTypeR: false });
        setSelectedVisa(undefined);
        setSpecialConstraints(undefined);

    }
    const onHideHistoryTable = () => {
        setReqTable({ contact_Person_Id: 0, open: false, loading: false });
        setAlreadyPostPoc(false)
    }


    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.rejected_Status === "yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
                setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID })
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };

    const dFooter = () => {
        return (
            // <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            //     <Button loading={loading} disabled={loading} className="p-button-sm my-1" form="requirementForm" label="SAVE" type={loading === false ? "submit" : "button"}></Button>
            //     <Button className="p-button-sm p-button-outlined my-1" label="CLEAR" onClick={onClear} type="button"></Button>
            // </div>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} disabled={loading} form="requirementForm" label="SAVE" type={loading === false ? "submit" : "button"} style={{ width: '100px' }} ></Button>
                <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" ></Button>
            </div>
        );
    }

    // const addAudioElement = (blob: Blob) => {
    //     const url = URL.createObjectURL(blob);
    //     const audio = document.createElement("audio");
    //     audio.src = url;
    //     audio.controls = true;
    //     document.body.appendChild(audio);
    // };
    const add_Date = (rowData: IClientTnfr) => {
        let date;
        if (rowData.add_Date) date = format(new Date(rowData.add_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const uploadAudio = async (blob: Blob) => {
        let formData = new FormData();
        formData.append("audio", blob);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Requirement_MAST/audio`, params);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Audio Uploaded Successfully." });
        }
    }

    const loadEscalationTableData = async (companyID: number) => {
        setEscalationTableData({ tableData: escalationTableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/getVendorEscalation", "GET", null, `poID=0&companyID=${companyID}`, props.toast);
        if (response) {
            const data: IEscalationList[] = await response.json();
            setEscalationTableData({ tableData: data, loading: false });
            setOpenEscalationModal({ singleData: {}, open: true });
        } else setEscalationTableData({ tableData: escalationTableData.tableData, loading: false });
    }

    useEffect(() => {
        if (data && recruiterAllocationAutoList && props.singleData.req_ID != 0) {
            let autoAlocateSkill = recruiterAllocationAutoList.filter((el: { req_CategoryID: number | undefined; }) => el.req_CategoryID == data.req_Category);
            if (autoAlocateSkill.length > 0) {
                setShwSkillDrp(autoAlocateSkill[0]);
            }
        }
    }, [data, recruiterAllocationAutoList]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Requirement" footer={dFooter} className="p-fluid" maximizable onHide={onHide}>
                <form id="requirementForm" onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    {/* <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}> */}
                    {/* <TabPanel header="Header I" className="p-fluid formgrid grid"> */}
                    {props.hideDialog && <div className="field col-12 md:col-5">
                        <JVDropdownInput column={1} icon="search" iconbg="warning" func={searchClients} required completeMethod={completeMethodClientCompanies} label="Client" control={control} name="client_company" error={errors.client_company?.vendor_Company_ID?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                        <div style={{ marginLeft: "20px", marginTop: "-10px", color: "#b7b7b8", fontWeight: "bold" }}>Min 3 char is required to search Client/Company</div>
                    </div>}
                    <JVDropdown column={4} label="Req Type" control={control} name="req_Type" error={errors.req_Type?.message} options={[{ id: 1, name: "Normal" }, { id: 2, name: "Tough" }]} optionLabel="name" optionValue="id" placeholder="Select Req Type" />
                    {vendorCompanyInfo && <><div className="field col-12 md:col-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', }}>
                        {vendorCompanyInfo.blacklisted ? <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px', background: 'red' }}></span>
                            : <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px', background: 'green' }}></span>}
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfReq}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfSub}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfECI}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '35px', width: '35px', border: "2px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfPo}</span>

                    </div>
                        {(vendorCompanyInfo && vendorCompanyInfo.blacklisted === true) && <div className="field col-12 md:col-3 -ml-2 text-xl font-bold flex flex-row-reverse w-full"><p style={{ color: 'red' }} className="">{vendorCompanyInfo.blackReason}</p></div>}
                    </>}
                    {/* {(vendorCompanyInfo && vendorCompanyInfo.blacklisted === true ) && <div className="flex flex-end w-full"><p style={{ color: 'red' }} className="">{vendorCompanyInfo.blackReason}</p></div>} */}
                    <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}>
                        <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", display: `${clients.clients?.length > 0 ? "block" : "none"}` }}
                            size="small"
                            value={clients.clients}
                        >
                            <Column header={<small className="p-error" >{errors.pV_Contact_PersonID?.message}</small>} body={radioBodyTemplate} />
                            <Column field="contact_Person_Name" header="Contact Person" />
                            <Column field="vendor_Company_Name" header="Company Name" />
                            {/* <Column header="Designation" body={dBodyTemplate} /> */}
                            <Column field="phone_No" header="Phone No" />
                            {/* <Column field="add_Date" header="Added Date" body={add_Date} /> */}
                            <Column field="add_Date" header="Added Date" body={(rowData: any) => safeFormatDate(rowData.add_Date, 'dd/MM/yyyy', DateFormat)} />
                            <Column field="noofReq" header="Req#" sortable />
                            <Column field="noOfServe" header="Serv#" sortable />
                            <Column field="noOfResume" header="Sub#" sortable />
                            <Column field="noEndClient" header="ECS#" sortable />
                            <Column field="noOfECI" header="ECI#" sortable />
                            <Column field="noOfPO" header="PO#" sortable />
                            <Column header="Status" body={sBodyTemplate} />
                            <Column header="Escalation" body={(rowData: IClientTnfr) => <Button className="p-button-rounded p-button-info p-button-text" type="button" tooltip="View Escalation" icon="pi pi-eye" onClick={() => {
                                if (rowData.vendor_Company_ID !== undefined && rowData.vendor_Company_ID !== null && rowData.vendor_Company_ID > 0) loadEscalationTableData(rowData.vendor_Company_ID || 0)
                            }}></Button>} />
                        </DataTable>
                    </div>
                    {/* </TabPanel> */}
                    {/* <TabPanel header="Header II" className="p-fluid formgrid grid"> */}

                    <JVInput required column={3} label="Job Title" control={control} name="req_Job_Title" error={errors.req_Job_Title?.message} />
                    <JVDropdown required column={3} label="Job Term" control={control} name="req_Term" error={errors.req_Term?.message} options={Term.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="id" placeholder="Select Term" />
                    {!formValues.isJTermP && <JVInput required column={3} label="Duration" control={control} name="req_Duration" error={errors.req_Duration?.message} />}
                    <JVDropdown required column={3} label="Job Type" control={control} name="job_Type" error={errors.job_Type?.message} options={JobType.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="id" placeholder="Select Job Type" />
                    <JVDropdownInput required={!formValues.isJTypeR} column={3} completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                    <JVDropdownInput required={!formValues.isJTypeR} column={3} completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                    <JVInput required column={3} label={formValues.isJTermP ? "Salary" : "Rate"} control={control} name="req_Rate" error={errors.req_Rate?.message} />
                    <JVDropdownInput column={3} completeMethod={completeMethodEndClient} label="End Client" control={control} name="endClient" error={errors.endClient?.end_Client_Id?.message} options={endClients} optionLabel="end_Client_Name" placeholder="Search End Client" />
                    <JVDropdown column={3} required label="Industry Type" control={control} name="industry_Id" options={industry} optionLabel="industry_Name" optionValue="industry_Id" placeholder="Select Industry Type" error={errors.industry_Id?.message} />
                    {/* <JVInput required column={3} label="End Client" control={control} name="req_EndClient" error={errors.req_EndClient?.message} /> */}
                    <JVDropdown required column={3} label="Positions" control={control} name="req_NoOfPositions" error={errors.req_NoOfPositions?.message} options={Positions} optionLabel="name" optionValue="id" placeholder="Select Positions" />
                    <JVDropdown required column={3} label="Resumes Per Position" control={control} name="req_NoOfResumePerPositions" error={errors.req_NoOfResumePerPositions?.message} options={ResumesPerPositions} optionLabel="name" optionValue="id" placeholder="Select Resumes Per Positions" />
                    <JVDropdown required column={3} label="Skills Category" control={control} name="req_Category" error={errors.req_Category?.message} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Skills Category" disabled={props.singleData.req_ID != 0 && true} />
                    <JVDropdown column={3} label="Sub Category" control={control} name="req_Sub_Category" error={errors.req_Sub_Category?.message} options={subskillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Sub Category" disabled={props.singleData.req_ID != 0 && true} />
                    <JVDropdown required column={3} label="Priority" control={control} name="req_Priority" error={errors.req_Priority?.message} options={Priority.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="id" placeholder="Select Priority" />
                    <JVDropdown required column={3} label="Client Category" control={control} name="reqType" error={errors.reqType?.message} options={clientCategories} optionLabel="reqType" optionValue="reqType_ID" placeholder="Select Client Category" disabled={canUpdate} />
                    <JVDropdown required column={3} label="Client Type" control={control} name="client_Type" options={client_Type} optionLabel="clientTypeName" optionValue="id" error={errors.client_Type?.message} placeholder="Select Client Type" />
                    {/* <JVDropdown required column={3} label="Work Authorization" control={control} name="visaId" error={errors.visaId?.message} options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="Select Visa" /> */}
                    <JVMultiselect column={3} label="Work Authorization" options={visa} optionLabel="visa_Name" placeholder="Select Visa" required value={selectedVisa} onChange={setSelectedVisa} />
                    <JVInput required type={"number"} column={3} label="Travel Required" control={control} name="travelReq" error={errors.travelReq?.message} />
                    <JVDropdown required column={3} label="Interview Process" control={control} name="req_InterviewProcess" error={errors.req_InterviewProcess?.message} options={InterviewProcess.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="id" placeholder="Select Interview Process" />
                    {/* <JVDropdown column={3} required label="Special Constraints" control={control} name="special_Constraint" options={special_Constraints} optionLabel="special_Constraints" optionValue="value" placeholder="Select Special Constraints " error={errors.special_Constraint?.message} /> */}

                    <JVMultiselect column={3} required label="Special Constraints" options={special_Constraints} optionLabel="name" value={specialConstraints} onChange={(e) => {
                        console.log(e);
                        if ((e || []).filter((f: any) => f.name === "No Constraints").length > 0) {
                            setSpecialConstraints([{ name: "No Constraints" }]);
                        }
                        else setSpecialConstraints(e);
                    }} placeholder="Select Special Constraints " />
                    {/* <JVDropdown required column={3} label="Client Communication" control={control} name="client_Communication" error={errors.client_Communication?.message} options={EClient_Communication} optionLabel="name" optionValue="name" placeholder="Select Client Communication" /> */}
                    <JVMultiselect column={3} label="Client Communication" options={EClient_Communication.filter((e, idx) => idx !== 0)} optionLabel="name" placeholder="Select Client Communication" required value={selectedEClient_Communication} onChange={setSelectedEClient_Communication} />

                    {/* <JVRadioBtn data={["Hold", "Unhold"]} column={3} required label="Status" control={control} name="req_Hold_UnHoldStatus" error={errors.req_Hold_UnHoldStatus?.message} /> */}
                    <JVInput column={3} required label="Skills Required" control={control} name="req_RequiredSkill" error={errors.req_RequiredSkill?.message} />
                    <JVInput column={2} label="Email Message ID" control={control} name="email_Message_ID" />
                    <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }} />

                    <JVCheckbox column={2} label="No Auto Allocation" control={control} name="no_Auto_Allocation" />
                    <div className="field col-12 md:col-2">
                        <label>Record Your Message</label>
                        <AudioRecorder onRecordingComplete={uploadAudio} />
                    </div>
                    {/* </TabPanel> */}
                    {/* <TabPanel header="Header III" className="p-fluid formgrid grid"> */}
                    <div className="col-12 md:col-12 md:col-6">
                        <label htmlFor="req_JobDescription">Job Description<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => { setDescription(editor.getData()); }} />
                        {/* <JVSunEditor value={description} handleChange={setDescription}/> */}
                        {/* <Editor style={{ height: '30vh' }} value={description} onTextChange={(e) => { if (e.htmlValue) setDescription(e.htmlValue) }} /> */}
                    </div>
                    <div className="col-12 md:col-12 md:col-6 mt-4">
                        <label htmlFor="req_JobDescription">Additional Info:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={additionInfo} onChange={(event, editor) => { setAdditionInfo(editor.getData()); }} />
                        {/* <JVSunEditor value={additionInfo} handleChange={setAdditionInfo}/> */}
                    </div>
                    {/* </TabPanel> */}
                    {/* </TabView> */}
                </form>
                {/*------------------------------- For History of today posted Requirements of same vendor company Start ----------------------------------------*/}

            </Dialog>
            <Dialog visible={reqTable.open} style={{ width: '80vw' }} header="History of today posted Req on this client" modal className="p-fluid" onHide={onHideHistoryTable} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={historyTableData.tableData}

                    loading={historyTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    {/* <Column field="req_ID" header="Req.ID" sortable body={req_ID} /> */}
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />

                </DataTable>
            </Dialog>

            <Dialog visible={alreadyPostPoc} style={{ width: '80vw' }} header="Requirement with this contact person and category already posted" modal className="p-fluid" onHide={onHideHistoryTable} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={existingPocData.tableData}

                    loading={existingPocData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />

                </DataTable>
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <p className="text-xl underline" style={{ color: "Red", fontWeight: "bolder" }}>Do you really want to post this Requirement?</p>
                    <div style={{ marginTop: '1px', marginBottom: '1px', width: '100%' }} />
                    <p className="text-xl underline" style={{ color: "Red", fontWeight: "bolder" }}>This requirement will be sent to Recruitment Head for approval.</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                        <Button icon="pi pi-check" disabled={contiune} loading={contiune} className="p-button-sm my-1 bg-green-500" label="Continue" type="button" onClick={() => { saveToDB(existingPoc); setContiune(true) }}></Button>
                        <Button icon="pi pi-times" className="p-button-sm p-button-danger my-1" label="Cancel" type="button" onClick={() => { setAlreadyPostPoc(false) }}></Button>
                    </div>

                </div>
            </Dialog>

            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>

            <Dialog visible={selfClietnModal.open} style={{ width: '80vw' }} header="Requirement with this contact person and category already posted" modal className="p-fluid" onHide={() => {
                setSelfClietnModal({ reqs: [], open: false });
                navigate("/salesRequirement");
            }} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={selfClietnModal.reqs}

                    loading={false}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="user_Name" header="Sales" sortable />
                    <Column field="company_Name" header="Company(Branch)" sortable body={(rowData: any) => <p>{rowData.company_Name} {`( ${rowData.branch_Name} )`}</p>} />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />

                </DataTable>
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <Button icon="pi pi-times" className="p-button-sm p-button-danger my-1" label="Close" type="button" onClick={() => {
                        navigate("/salesRequirement");
                        setSelfClietnModal({ reqs: [], open: false });
                    }}></Button>
                </div>
            </Dialog>
            <Dialog visible={openEscalationModal.open} style={{ width: '80vw' }} header="PV Escalation" className="p-fluid" onHide={() => {
                setOpenEscalationModal({ singleData: {}, open: false });
                setEscalationTableData({ tableData: [], loading: false });
            }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" value={escalationTableData.tableData} loading={escalationTableData.loading} showGridlines stripedRows responsiveLayout="scroll"
                >
                    <Column field="vendor_Type" header="Vendor Type" body={(rowData: IEscalationList) => <p>{rowData.vendor_Type === 1 ? "Prime Vendor" : "Sub Vendor"}</p>} />
                    <Column field="vendor_Company_Name" header="Vendor Company" />
                    <Column field="added_By" header="Added By" />
                    <Column field="company" header="Company" />
                    <Column field="branch" header="Branch" />
                    <Column field="escalation_Subject" header="Escalation Subject" body={(rowData: any) => <div className="flex"><div className={"knob1" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.escalation_Subject}<Tooltip target={".knob1" + rowData.id} position="top" content={`${rowData.escalation_Subject?.trim()}`} /></div><span style={{ color: "#2196F3" }}>{rowData.escalation_Subject?.trim().length > 5 ? "..." : ""}</span></div>} />
                    <Column field="escalation_Comment" header="Escalation Comment" body={(rowData: any) => <div className="flex"><div className={"knob2" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.escalation_Comment}<Tooltip target={".knob2" + rowData.id} position="top" content={`${rowData.escalation_Comment?.trim()}`} /></div><span style={{ color: "#2196F3" }}>{rowData.escalation_Comment?.trim().length > 5 ? "..." : ""}</span></div>} />
                    <Column field="escalation_Status" header="Status" />
                </DataTable>
            </Dialog>
        </>
    );
}